import useServerTime from './useServerTime.js';

export default function AnalogClock({ axiosInstance }) {
  const time = useServerTime(axiosInstance);

  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours() % 12;

  const secondDeg = seconds * 6;
  const minuteDeg = minutes * 6 + seconds * 0.1;
  const hourDeg = hours * 30 + minutes * 0.5;

  const hourMarkers = Array.from({ length: 12 }, (_, i) => {
    const angle = (i * 30 * Math.PI) / 180;
    const isMain = i % 3 === 0;
    const outerR = 38;
    const innerR = isMain ? 32 : 34;
    return {
      x1: 50 + Math.sin(angle) * innerR,
      y1: 50 - Math.cos(angle) * innerR,
      x2: 50 + Math.sin(angle) * outerR,
      y2: 50 - Math.cos(angle) * outerR,
      isMain,
    };
  });

  return (
    <div className="clock-face relative h-14 w-14 rounded-full flex-shrink-0">
      <svg viewBox="0 0 100 100" className="w-full h-full">
        {hourMarkers.map((m, i) => (
          <line
            key={i}
            x1={m.x1}
            y1={m.y1}
            x2={m.x2}
            y2={m.y2}
            stroke={m.isMain ? 'var(--nad-accent-txt)' : 'var(--nad-clock-tick)'}
            strokeWidth={m.isMain ? 2 : 1}
            strokeLinecap="round"
          />
        ))}
        <line
          x1="50" y1="50" x2="50" y2="26"
          stroke="var(--nad-clock-hand)"
          strokeWidth="2.5"
          strokeLinecap="round"
          transform={`rotate(${hourDeg}, 50, 50)`}
        />
        <line
          x1="50" y1="50" x2="50" y2="18"
          stroke="var(--nad-clock-hand2)"
          strokeWidth="1.8"
          strokeLinecap="round"
          transform={`rotate(${minuteDeg}, 50, 50)`}
        />
        <line
          x1="50" y1="56" x2="50" y2="16"
          stroke="var(--nad-accent-txt)"
          strokeWidth="1"
          strokeLinecap="round"
          transform={`rotate(${secondDeg}, 50, 50)`}
        />
        <circle cx="50" cy="50" r="2.5" fill="var(--nad-accent-txt)" />
        <circle cx="50" cy="50" r="1.2" fill="var(--nad-clock-hub)" />
      </svg>
    </div>
  );
}
